import { HazardType } from "generated-graphql/graphql";

import { ChemicalDetailInputs } from ".";

type StoredHazardCategory = { code: string; hazardType: HazardType };

/**
 * Form values for the two hazard pickers. Undefined when the pickers are not
 * shown, so the save input omits the list and the server leaves hazard rows alone.
 */
export function seedHazardCategoryCodes(
  chemical: { hazardCategories?: readonly StoredHazardCategory[] | null } | undefined,
  usesHazardCategories: boolean
): Pick<ChemicalDetailInputs, "healthHazardCategoryCodes" | "physicalHazardCategoryCodes"> {
  if (!usesHazardCategories) {
    return { healthHazardCategoryCodes: undefined, physicalHazardCategoryCodes: undefined };
  }
  const codesOf = (hazardType: HazardType) =>
    (chemical?.hazardCategories ?? [])
      .filter((category) => category.hazardType === hazardType)
      .map((category) => category.code);
  return {
    healthHazardCategoryCodes: codesOf(HazardType.Health),
    physicalHazardCategoryCodes: codesOf(HazardType.Physical),
  };
}
